module.exports = __webpack_public_path__ + "img/käyntisatama_original.67e65276.jpg";